import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Title = styled.h1`
    font: normal normal normal 39px Circular Std Book;
    color: ${colors.primary};
    margin-bottom: 10px;

    @media (max-width: 500px){
        font: normal normal normal 28px Circular Std Book;
    }
`

export const Subtitle = styled.p`
    font: normal normal normal 12px Circular Std Book;
    color: ${colors.tertiary};

    @media (max-width: 500px){
        font: normal normal normal 10px Circular Std Book;
    }
`

export const Close = styled.button`
    width: 30px;
    height: 30px;
    padding: 0px;
    border: none;
    outline: none;
    background-color: ${colors.white};

    &:focus{
        outline: none;
    }
`
